import styled from 'styled-components';

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small || '0.625rem'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    gap: 0.3125rem;
  }
`;

export default ProfileContainer;
